import navTree from "@stanza/shared/nav-tree.json";
import { getPageRoute } from "src/services";

/**
 * Label + icon per section category slug, for `/explore/:category` resolution
 * (`categoryLabel`). Not derived from shared `SECTION_CATEGORIES`
 * (`@stanza/shared/sections`) because the sets differ on purpose: this covers
 * every category a Section can carry (`Section.category` is a free string —
 * e.g. movies), while the shared list only scopes the nightly generator. The
 * nav *display* list is `nav-tree.json`.
 */
export const EXPLORE_CATEGORIES = [
  { slug: "sports", label: "Sports", icon: "sports_basketball" },
  { slug: "tv", label: "TV", icon: "live_tv" },
  { slug: "movies", label: "Movies", icon: "movie" },
  { slug: "music", label: "Music", icon: "music_note" },
  { slug: "general", label: "General", icon: "explore" },
];

/** US-only Elections entry, pinned to the top of the Explore section (above Sports). */
export const ELECTIONS_ITEM = {
  label: "US Elections",
  compactLabel: "Elections",
  icon: "how_to_vote",
  to: getPageRoute("elections", "US_ELECTIONS"),
  testId: "sidebar-elections",
  usOnly: true,
  badge: "New",
};

/** Standalone Home entry, pinned above the sidebar sections and in the compact rail. */
export const HOME_ITEM = {
  label: "Home",
  icon: "home",
  to: getPageRoute("home", "HOME"),
  testId: "sidebar-home",
};

export const SIDEBAR_SECTIONS = [
  {
    key: "you",
    label: "You",
    items: [
      { label: "Library", icon: "newsstand", to: getPageRoute("library", "LIBRARY"), testId: "sidebar-library" },
      {
        label: "Create",
        icon: "add_circle",
        to: "/creators",
        testId: "home-user-import",
      },
    ],
  },
  {
    key: "explore",
    label: "Explore",
    // Nav display categories come from nav-tree.json (the single source for the
    // browse surfaces); the expanded sidebar swaps these for the nested tree.
    items: navTree.categories.map((category) => ({
      label: category.label,
      icon: category.icon,
      to: getPageRoute("home", "EXPLORE_CATEGORY", { category: category.tag }),
    })),
  },
  {
    key: "premium",
    label: "Premium",
    items: [
      {
        label: "Stanza+ Perks",
        icon: "workspace_premium",
        to: getPageRoute("upgrade", "UPGRADE_PLUS"),
        // Members go straight to their membership page instead of the checkout.
        memberTo: getPageRoute("upgrade", "MEMBERSHIP"),
      },
    ],
  },
];

/**
 * Resolves a category slug to its display label.
 *
 * @param {string} slug
 * @returns {string} The label, or the slug itself when unknown.
 */
export function categoryLabel(slug) {
  return EXPLORE_CATEGORIES.find((c) => c.slug === slug)?.label ?? slug;
}
